import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  IFaultCodeMapping,
  IFaultCodeMappingRow,
} from '../../../../view/settings/api-automation-settings/fault-code-mapping/fault-code-mapping.model';

@Injectable({
  providedIn: 'root',
})
export class FaultCodeMappingService {
  private readonly FAULT_CODE_MAPPING_URL = `${this.baseUrl}/api-automation/fault-code-mapping`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<IFaultCodeMapping>> {
    return this.http.get<GetManyResponseInterface<IFaultCodeMapping>>(this.FAULT_CODE_MAPPING_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<IFaultCodeMapping>> {
    return this.http.get<BaseOneResponseInterface<IFaultCodeMapping>>(`${this.FAULT_CODE_MAPPING_URL}/${recordId}`, {
      params,
    });
  }

  public addOne(record: IFaultCodeMappingRow): Observable<BaseOneResponseInterface<IFaultCodeMapping>> {
    return this.http.post<BaseOneResponseInterface<IFaultCodeMapping>>(this.FAULT_CODE_MAPPING_URL, record);
  }

  public editOne(
    recordId: number,
    record: IFaultCodeMappingRow,
  ): Observable<BaseOneResponseInterface<IFaultCodeMapping>> {
    return this.http.patch<BaseOneResponseInterface<IFaultCodeMapping>>(
      `${this.FAULT_CODE_MAPPING_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          faultCodeMappings: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.FAULT_CODE_MAPPING_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.FAULT_CODE_MAPPING_URL}/${recordIds[0]}`);
  }
}
